export default __webpack_public_path__ + "static/media/julian_sharp.02837f7b.png";